import React from 'react';
import { useLocation } from 'react-router-dom';
import './MainHeader.css';



const MainHeader = props => {
  const location = useLocation();
  let path = location ? ((location.pathname).split('/'))[1] : "";

  return <header className={path === "print" ? "nav-block" : "main-header"} >{props.children}</header>;
};

export default MainHeader;
